import React, { Component } from 'react';
import { connect } from 'react-redux';
import Input from 'react-toolbox/lib/input';

const defaults = {
};

class ProductionQueueDistributorSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      outdata: {
        ...defaults,
        ...props.indata
      }
    };
  }

  componentDidMount() {
    this.onChange();
  }

  onChange() {
    this.props.onChange(this.state.outdata);
  }

  setOutdataValue(property, value) {
    this.setState(
      { outdata: { ...this.state.outdata, [property]: value } },
      this.onChange
    );
  }

  render() {
    return (
      <div>
        <Input
          value={this.state.outdata.title}
          onChange={val => this.setOutdataValue('title', val)}
          label="Title"
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps, null, null, { pure: false })(
  ProductionQueueDistributorSettings
);



// WEBPACK FOOTER //
// ./app/widgets/ProductionQueueDistributor/settings.js